// brand_image may be a full URL (/channel_info) or a host-less signed fragment
// (/onboarding/channel). Only the former is usable on a logged-out page.
export function resolveBrandImageUrl(brandImage: string | null, serverBaseUrl: string | undefined): string | null {
  if (!brandImage) return null
  if (/^https?:\/\//i.test(brandImage)) return brandImage
  if (serverBaseUrl) return `${serverBaseUrl}/files/${brandImage}`
  return null
}
